import { render, staticRenderFns } from "./VBtnMenu.vue?vue&type=template&id=4ec2d742&scoped=true&functional=true"
import script from "./VBtnMenu.vue?vue&type=script&lang=js"
export * from "./VBtnMenu.vue?vue&type=script&lang=js"
import style0 from "./VBtnMenu.vue?vue&type=style&index=0&id=4ec2d742&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4ec2d742",
  null
  
)

export default component.exports